<div class="row" style="width: 100%; margin: 0px;">
  <div class="col-sm-12" style="padding: 0;">
    @if (this.hasData) {
      <div class="pc-timeline">
        <apx-chart
          [series]="series"
          [chart]="chart"
          [plotOptions]="plotOptions"
          [xaxis]="xaxis"
          [yaxis]="yaxis"
          [grid]="grid"
          [dataLabels]="dataLabels"
          [annotations]="annotations"
          [tooltip]="tooltip"
          [colors]="fillColors">
        </apx-chart>
      </div>
    }

    @if (!this.hasData) {
      <div>{{this.errorMessage}}</div>
    }
  </div>
</div>
